import React, {useContext} from 'react';
import {bool} from 'prop-types';
import cx from 'classnames';
import {animated, useTransition} from 'react-spring';
import Button from '../button';
import FormNavigation from '../form-navigation';
import FormStepContext from './FormStepContext';
import If from '../../misc/If';

import './FormControls.css';

const propTypes = {
  isCentered             : bool.isRequired,
  isStepSubmitted        : bool.isRequired,
  isStepValid            : bool.isRequired,
  showNavigationControls : bool.isRequired,
  showSkipButton         : bool.isRequired
};

function FormControls (props) {
  const {
    isCentered,
    isStepSubmitted,
    isStepValid,
    showNavigationControls,
    showSkipButton
  } = props;
  /* Not the form's raw onSkipStep: the step has to report itself before it is left. */
  const {handleOnSkipStep} = useContext(FormStepContext);

  const transitions = useTransition(isStepValid, null, {
    from : {
      position  : 'absolute',
      opacity   : 0,
      transform : 'translate3d(0, 50px, 0)',
      width     : '100%'
    },
    enter : {
      opacity   : 1,
      transform : 'translate3d(0, 0px, 0)',
    },
    leave : {
      opacity : 0
    }
  });

  return (
    <If condition={showNavigationControls}>
      {() => (
        <section className="form-step__controls" key="step-controls">
          {transitions.map(({item, key, props}) => (
            item && (
              <animated.div key={key} style={props}>
                <FormNavigation isCentered={isCentered} />
              </animated.div>
            )
          ))}

          <If condition={showSkipButton}>
            <Button
              className={cx('form-step__skip', {
                'form-step__skip--moved' : isStepValid
              })}
              onClick={handleOnSkipStep}
              size={Button.SIZE.SMALL}
              type={Button.TYPE.SECONDARY}
            >
              Skip
            </Button>
          </If>
        </section>
      )}
    </If>
  );
}

FormControls.propTypes = propTypes;

export default FormControls;
